<template>
    <kgr-searchable-dropdown
        display="title"
        :label="label"
        :options="filteredExams"
        :loading="loading"
        inline
        @post-input="onInput"
    />
</template>

<script>
import ClubExam from '../../../../js/dto/club/ClubExam.js';
import ClubExamRepository from '../../../../js/repository/club/ClubExamRepository.js';
import SearchableDropdown from './SearchableDropdown.vue';

export default {
    components: {
        'kgr-searchable-dropdown': SearchableDropdown,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        value: {
            type: ClubExam,
            required: false,
            default: () => {
                return null;
            },
        },
        excludedIds: {
            type: Array,
            required: false,
            default: () => {
                return [];
            },
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
        examineeType: {
            type: String,
            required: false,
            default: null,
            validator(value) {
                return [ClubExam.EXAMINEE_TYPE_DOG, ClubExam.EXAMINEE_TYPE_MEMBER, null].includes(value);
            },
        },
        excludeArchived: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            exams: [],
        };
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('exam');
        },
        filteredExams() {
            return this.exams.filter((exam) => this.excludedIds.indexOf(exam.id) === -1);
        },
    },
    created() {
        const params = {};
        if (this.examineeType) {
            params.examineeType = this.examineeType;
        }
        params.includeArchived = !this.excludeArchived;
        ClubExamRepository.findByClubId(this.clubId, params)
            .then((data) => this.exams = data)
            .catch(() => this.$notify.error('error.loadingData'))
            .finally(() => this.loading = false);
    },

    methods: {
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    },
};
</script>
